import { render, staticRenderFns } from "./InboundItem.vue?vue&type=template&id=3958da36&"
import script from "./InboundItem.vue?vue&type=script&lang=js&"
export * from "./InboundItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports